/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useEffect, useState, useRef } from 'react'
import Button from 'Admin/elements/CustomButton/CustomButton.jsx';
import { savePatientNextVisitInstructions } from 'Front/api/nextVisitInstructions'
import * as API from 'Front/api/emr';
import NotificationSystem from 'react-notification-system';
import { style } from "Admin/variables/Variables.jsx";
import {
    Row, Col,
    Modal, Form, FormGroup, ControlLabel, FormControl
} from 'react-bootstrap';
import { confirmAlert } from "react-confirm-alert";

const NextVisitInstructionModal = ({ showNextVisitInstructionModel, setShowNextVisitInstructionModel, nextVisitInstructionList, setNextVisitInstructionList, patientId, appointmentId, setInstructionString, arrNextVisitInstructions, setArrNextVisitInstructions }) => {
    const showRecommendationFun = () => {
        setShowNextVisitInstructionModel(true);
    }
    const [isInstructionAlreadyExist, setIsInstructionAlreadyExist] = useState(false)
    const [maxLength, setMaxLength] = useState(false)
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const notificationSystem = useRef(null)
    const [isDisabledAddToClinicButton, setIsDisabledAddToClinicButton] = useState(true)

    const inputHandler = (e) => {
        let saveFormData = formData;
        if (e.target.name === "instruction") {
            if (e.target.value.length >= 300) {
                setMaxLength(true)
                setIsDisabledAddToClinicButton(true)
                return
            } else {
                setMaxLength(false)
                let str = e.target.value.replace(/\s+/g, " ").substring(0, 300);
                saveFormData[e.target.name] = str.trimStart()
                setFormData({ ...formData, ...saveFormData });
            }
        }


        setIsInstructionAlreadyExist(false)
        validate();
    }

    const validate = () => {

        let post = formData;
        let errArr = errors;
        let errflag = true;
        if (post.instruction && post.instruction != '') {
            errArr.instruction = '';
            setIsDisabledAddToClinicButton(false)
        } else {
            errArr.instruction = 'error';
            errflag = false;
            setIsDisabledAddToClinicButton(true)
        }
        setErrors({ ...errArr });
        return errflag;

    }

    const confirmToAdd = () => {
        confirmAlert({
            title: "Confirm To Add",
            message: "Are you sure you want to add instruction to clinic?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        addCustomInstruction()
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const addCustomInstruction = async () => {

        const trimmedInstruction = formData.instruction?.trim();
        setFormData({ ...formData, instruction: trimmedInstruction });

        if (!validate()) return;

        try {
            const resp = await API.addNextVisitInstruction({
                instruction: trimmedInstruction,
                clinicId: localStorage.getItem("clinicId")
            });

            if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
                notificationSystem.current.addNotification({
                    title: (
                        <span
                            data-notify="icon"
                            className="pe-7s-check"
                            style={{ fontSize: '30px', color: '#fff' }}
                        />
                    ),
                    message: <div>Instruction Saved Successfully</div>,
                    level: 'success',
                    position: 'tr',
                    autoDismiss: 2,
                });

                const newInstruction = {
                    _id: resp.data.customInstructionData._id,
                    instruction: resp.data.customInstructionData.instruction,
                    type: resp.data.customInstructionData.type,
                    clinicId: resp.data.customInstructionData.clinicId,
                    isDeleted: resp.data.customInstructionData.isDeleted,
                    checked: true
                };

                const updatedList = [...nextVisitInstructionList, newInstruction];
                setNextVisitInstructionList(updatedList);
                setArrNextVisitInstructions(updatedList);
                setFormData({})
                setErrors({})
            }
        } catch (err) {
            if (err.response && err.response.status === 500)
                setIsInstructionAlreadyExist(true)
            console.error("Error while adding custom instruction:", err);
        }
    };

    const addOrDelete = (e, row) => {
        const updatedList = arrNextVisitInstructions.map((instruction) => {
            if (instruction._id === row._id) {
                return { ...instruction, checked: e.target.checked };
            }
            return instruction;
        });
        setArrNextVisitInstructions([...updatedList]);
    };

    useEffect(() => {
        if (showNextVisitInstructionModel)
            setArrNextVisitInstructions([...nextVisitInstructionList])
    }, [showNextVisitInstructionModel])

    const formateInstruction = () => {
        const formattedText = arrNextVisitInstructions
            .filter((ins) => ins.checked)
            .map((ins) => `${ins.instruction}`)
            .join(" / ");
        setInstructionString(formattedText);
        return formattedText;
    }

    const submitHandler = async () => {
        try {
            const instructionString = formateInstruction()
            let instructionIds = arrNextVisitInstructions.reduce(
                (ids, ele) => (ele?.checked ? [...ids, ele._id] : ids),
                []
            );
            let resp = await savePatientNextVisitInstructions({ patientId, visitId: appointmentId, clinicId: localStorage.getItem("clinicId"), instructionIds, nextVisitInstruction: instructionString })
            if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
                setNextVisitInstructionList([...arrNextVisitInstructions])
                setShowNextVisitInstructionModel(false)
            }
        } catch (error) {
            console.log("Error while saving next visit instructions")
        }
    }

    return (
        <span style={{ float: "left" }}>
            <Button type="button" id="btnShowNextVisitInstruction" onClick={(e) => showRecommendationFun()} className="btn btn-fill btn-primary">Next Visit Instruction</Button>
            <Modal show={showNextVisitInstructionModel} onHide={() => setShowNextVisitInstructionModel(false)} dialogClassName="modal-xl">
                <Modal.Header closeButton className="bg-thumbcolor">
                    <div>
                        <NotificationSystem ref={notificationSystem} style={style} />
                    </div>
                    <Modal.Title id="example-modal-sizes-title-lg">Next Visit Instruction</Modal.Title>
                </Modal.Header>
                <Modal.Body className="suggetion-box-enlarge">
                    <div className="suggestion-lists">
                        <div className="selected-complaints">
                            <h5>Next Visit Instructions Selected</h5>
                        </div>
                        <div className="suggestion-list">
                            {
                                arrNextVisitInstructions.map((itm, idx) => {
                                    return (<div class="form-check form-check-emr">
                                        <input checked={itm?.checked} class="form-check-input" id={itm._id} type="checkbox" value={itm.instruction} onChange={(e) => { addOrDelete(e, itm) }} name="instruction" />
                                        <label class="form-check-label" for={itm._id}>
                                            {itm.instruction}
                                        </label>
                                    </div>)

                                })
                            }

                        </div>
                        <div className='row'>
                            <div className='col-sm-6' style={{ marginTop: '15px' }}>
                                <form >
                                    {isInstructionAlreadyExist &&
                                        <div style={{ 'color': 'red' }}><p>This instruction already exist.</p></div>
                                    }
                                    <FormGroup>
                                        <Col sm={12} >
                                            {maxLength &&
                                                <span style={{ 'color': 'red' }}><p>Maximum 300 Characters are allowed.</p></span>
                                            }
                                            <FormControl rows="3" style={{ marginBottom: "10px" }} maxLength="300" componentClass="textarea" id="txtInstruction" name="instruction" bsClass="form-control unmandt-f" value={formData?.instruction ? formData?.instruction : ''} placeholder="Instruction" onChange={e => { inputHandler(e); }} className={'' + (errors.instruction ? errors.instruction : '')} />
                                        </Col>
                                        <Col componentClass={ControlLabel} sm={12} >
                                            <Button onClick={e => confirmToAdd()} className="btn btn-fill btn-primary" disabled={isDisabledAddToClinicButton}> Add To Clinic</Button>
                                        </Col>
                                    </FormGroup>

                                </form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm-6' style={{ marginTop: '15px' }}>

                            </div>
                            <hr></hr>
                        </div>
                        <div className='text-right'>
                            <Button onClick={e => submitHandler(e)} className="btn btn-primary btn-fill right">Save</Button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </span>
    )
}

export default NextVisitInstructionModal